export const parseJSONImpl = JSON.parse
